import "core-js/stable";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { App } from "./containers/App";

import "bootstrap/dist/css/bootstrap.css";
import "react-select/dist/react-select.css";
import "react-big-calendar/lib/sass/styles.scss";
import "react-datetime/css/react-datetime.css";
import "intro.js/introjs.css";

import "moment/locale/en-gb";
import "moment/locale/fi";
import "moment/locale/nb";
import "moment/locale/se";

import "./index.css";

import * as serviceWorker from "./serviceWorker";
window.__sessionId = 0;
window.__sessionId2 = -1;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
